
export const ADD_MESSAGE_REQUEST = 'QUESTIONS/ADD_MESSAGE_REQUEST';
export const ADD_MESSAGE_SUCCESS = 'QUESTIONS/ADD_MESSAGE_SUCCESS';
export const ADD_MESSAGE_FAIL = 'QUESTIONS/ADD_MESSAGE_FAIL';
export const GET_MESSAGE_REQUEST = 'QUESTIONS/GET_MESSAGE_REQUEST'
export const GET_MESSAGE_SUCCESS = 'QUESTIONS/GET_MESSAGE_SUCCESS'
export const GET_MESSAGE_FAIL = 'QUESTIONS/GET_MESSAGE_FAIL'

